import { CommApiInstance } from "Utils/CommApiInstance";

const BlckMembInqApi = async (
    loginId:string,
    
) => {
    return await CommApiInstance.post(`comm/blck/${loginId}`,{
        apiBody:{
        },
    })
    .then((Resp) => Resp.data);
}
export default BlckMembInqApi;